export function normalizeMentionLabel(value) {
  return String(value ?? '').trim().toLowerCase()
}
